const expand = (n, a, radix) => {
    if (n === 0) {
        return a;
    }
    else {
        return expand (Math.round(n / radix), a.concat(n % radix), radix);
    }
};

const stringToArray = str => {
    let arr = [];
    for (let i = 0; i < str.length; ++i) {
        arr.push (str.charAt(i));
    }
    return arr;
};

const pad = (origin, str, width, sym) => {
    let s = stringToArray (str);
    for (let i = 0; s.length < width; ++i) {
        if (origin === 'left') {
            s.splice (0, 0, sym);
        }
        else {
            s.push (sym);
        }
    }
    return s.join('');
};

const padLeft = (str, sym, width) => pad ('left', str, width, sym);
const padRight = (str, sym, width) => pad ('right', str, width, sym);

const get_hash = values => {
    if (Array.isArray (values) && values.length > 0) {
        return btoa (values.join(''));
    }
    else if (typeof values === 'string') {
        return btoa(values);
    }
    else {
        return null;
    }
};

const memoize = fun => {
    let acc = {};
    return (...args) => {
        const h = get_hash (args);
        if (!acc.hasOwnProperty(h)) {
            acc[h] = fun.apply(null, args);
        }    
        return acc[h]; 
    };
};

export {expand, stringToArray, pad, padLeft, padRight, memoize};